const toDate = (value) => {
    if (!value) return null;

    if (value.$date || value['$date']) {
        const parsed = new Date(value.$date || value['$date']);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    if (typeof value.toDate === 'function') {
        return value.toDate();
    }

    if (typeof value.seconds === 'number') {
        return new Date(value.seconds * 1000);
    }

    if (value instanceof Date) {
        return value;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/** Timestamp in ms for sorting (newest first). */
export const getCommentTimestamp = (comment) => {
    const date = toDate(comment?.created_at) || toDate(comment?.date);
    return date ? date.getTime() : 0;
};

export const sortCommentsNewestFirst = (comments) => {
    if (!comments?.length) return [];
    return [...comments].sort(
        (a, b) => getCommentTimestamp(b) - getCommentTimestamp(a)
    );
};

const MONTHS_SHORT = [
    'ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.',
    'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.',
];

/** Human-readable publication date in Spanish. */
export const formatCommentDate = (comment) => {
    const date = toDate(comment?.created_at) || toDate(comment?.date);
    if (!date) return '';

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Ahora';
    if (diffMins < 60) return `Hace ${diffMins} min`;
    if (diffHours < 24) return `Hace ${diffHours} h`;
    if (diffDays === 1) return 'Ayer';

    const sameYear = date.getFullYear() === now.getFullYear();
    const day = date.getDate();
    const month = MONTHS_SHORT[date.getMonth()];

    if (sameYear) {
        return `${day} ${month}`;
    }

    return `${day} ${month} ${date.getFullYear()}`;
};
